import React, { Component } from 'react';
import { compareByNome } from 'utils/orderHelper';
import BuscaAvancada, { BuscaAvancadaContext } from '../../../components/BuscaAvancada/buscaAvancada.component';
import Input from '../../../components/Input/input.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import { MESSAGES } from '../../../constants/messages';
import AlertaService from '../../../services/alertaService';
import SelectService from '../../../services/comumService';
import CrepdecService from '../../../services/crepdecService';
import MunicipioService from '../../../services/municipioService';
import ToastHelper from '../../../utils/toastHelper';

class PesquisaAvancadoPrestacaoContas extends Component {
	state = {
		origens: [],
		municipios: [],
		categorias: [],
		crepdecs: [],
		status: [],
		urgencias: [],
		confiancas: [],
	}

	componentDidMount() {
		MunicipioService.findAll().then((response) => {
			this.setState({
				municipios: response.data,
			});
		});

		SelectService.findAllOrgaos().then((response) => {
			this.setState({
				origens: this.orderItens(response.data),
			});
		});

		SelectService.findAllCategorias().then((response) => {
			this.setState({
				categorias: this.orderItens(response.data),
			});
		});

		SelectService.findAllUrgencias().then((response) => {
			this.setState({
				urgencias: this.orderItens(response.data),
			});
		});

		SelectService.findAllConfiancas().then((response) => {
			this.setState({
				confiancas: this.orderItens(response.data),
			});
		});

		CrepdecService.findAll().then((response) => {
			this.setState({
				crepdecs: response.data,
			});
		});

		AlertaService.findAllStatusAlerta().then((response) => {
			this.setState({
				status: this.orderItens(response.data),
			});
		});
	}

	orderItens = (itens) => {
		itens.sort(compareByNome);
		return itens;
	};

	render() {
		const {
			props: {
				filtro,
				handlePesquisaSimplificada,
				serviceSearch,
			},
			state: {
				crepdecs,
				status,
				origens,
				municipios,
				categorias,
				urgencias,
				confiancas,
			},
		} = this;

		return (
			<BuscaAvancada
				initialValues={filtro}
				handleSearch={(values) => {
					const filtroFinal = {};
					Object.assign(filtroFinal, values);

					filtroFinal.identificador = values.identificador !== ''
						? values.identificador : null;

					filtroFinal.responsavel = values.responsavel !== ''
						? values.responsavel : null;

					filtroFinal.periodoInicialEmissao = values.periodoInicialEmissao !== ''
						? values.periodoInicialEmissao : null;

					filtroFinal.periodoFinalEmissao = values.periodoFinalEmissao !== ''
						? values.periodoFinalEmissao : null;

					filtroFinal.idCategoriaEventoList = values.categoriaList !== undefined
						&& values.categoriaList.length > 0
						? values.categoriaList.map(item => item.object.id) : null;

					filtroFinal.idStatusList = values.statusList !== undefined
						&& values.statusList.length > 0
						? values.statusList.map(item => item.object.id) : null;

					filtroFinal.idIniciadorList = values.origemList !== undefined
						&& values.origemList.length > 0
						? values.origemList.map(item => item.object.id) : null;

					filtroFinal.idUrgenciaList = values.urgenciaList !== undefined
						&& values.urgenciaList.length > 0
						? values.urgenciaList.map(item => item.object.id) : null;

					filtroFinal.idCrepdecList = values.crepdecList !== undefined
						&& values.crepdecList.length > 0
						? values.crepdecList.map(item => item.object.id) : null;

					filtroFinal.municipiosList = values.municipiosList !== undefined
						&& values.municipiosList.length > 0
						? values.municipiosList.map(item => item.object.codigoIbge) : null;

					filtroFinal.idConfiancaList = values.confiancaList !== undefined
						&& values.confiancaList.length > 0
						? values.confiancaList.map(item => item.object.id) : null;

					if (filtroFinal.periodoInicialEmissao > filtroFinal.periodoFinalEmissao) {
						ToastHelper.warn(MESSAGES.PERIODO_EMISSAO_INVALIDO);
					} else {
						serviceSearch(filtroFinal);
					}
				}}
				handleClear={({ resetForm }) => {
					resetForm();
					serviceSearch(filtro);
				}}
				handlePesquisaSimplificada={handlePesquisaSimplificada}
			>
				<BuscaAvancadaContext.Consumer>
					{({
						values,
						handleChange,
						setFieldValue,
					}) => (
						<React.Fragment>
							<div className='row mt-3'>
								<div className='col-6'>
									<label>Identificador</label>
									<Input
										type='number'
										name='identificador'
										onChange={handleChange}
										value={values.identificador || ''}
									/>
								</div>

								<div className='col-6'>
									<label>Categoria do evento</label>
									<SelectMulti
										isMulti
										isClearable
										name='categoriaList'
										uniqueKey='id'
										label='nome'
										options={categorias}
										value={values.categoriaList || []}
										onChange={(item) => {
											setFieldValue('categoriaList', item);
										}}
									/>
								</div>
							</div>

							<div className='row'>
								<div className='col-6'>
									<label>Origem da informação</label>
									<SelectMulti
										isMulti
										isClearable
										name='origemList'
										uniqueKey='id'
										label='nome'
										options={origens}
										value={values.origemList || []}
										onChange={(item) => {
											setFieldValue('origemList', item);
										}}
									/>
								</div>
								<div className='col-6'>
									<label>Status</label>
									<SelectMulti
										isMulti
										isClearable
										name='statusList'
										uniqueKey='id'
										label='nome'
										options={status}
										value={values.statusList || []}
										onChange={(item) => {
											setFieldValue('statusList', item);
										}}
									/>
								</div>
							</div>

							<div className='row  mt-2'>
								<div className='col-6'>
									<label>	Período de emissão</label>
									{/* <DateRangePicker /> */}
									<div className='row'>
										<div className='col-1 mt-1'>
											<label>De: </label>
										</div>
										<div className='col-5'>
											<Input
												type='date'
												name='periodoInicialEmissao'
												className='form-control'
												onChange={handleChange}
												value={values.periodoInicialEmissao || ''}
											/>
										</div>
										<div className='col-1 mt-1'>
											<label>Até: </label>
										</div>
										<div className='col-5'>
											<Input
												type='date'
												name='periodoFinalEmissao'
												onChange={handleChange}
												value={values.periodoFinalEmissao || ''}
											/>
										</div>
									</div>
								</div>
								<div className='col-6'>
									<label>Urgência</label>
									<SelectMulti
										isMulti
										isClearable
										name='urgenciaList'
										uniqueKey='id'
										label='nome'
										options={urgencias}
										value={values.urgenciaList || []}
										onChange={(item) => {
											setFieldValue('urgenciaList', item);
										}}
									/>
								</div>
							</div>

							<div className='row  mt-2'>
								<div className='col-6'>
									<label>Confiança</label>
									<SelectMulti
										isMulti
										isClearable
										name='confiancaList'
										uniqueKey='id'
										label='nome'
										options={confiancas}
										value={values.confiancaList || []}
										onChange={(item) => {
											setFieldValue('confiancaList', item);
										}}
									/>
								</div>
								<div className='col-6'>
									<label>Responsável</label>
									<Input
										type='input'
										name='responsavel'
										onChange={handleChange}
										value={values.responsavel || ''}
									/>
								</div>
							</div>

							<div className='row  mt-2'>
								<div className='col-6'>
									<label>CREPDEC</label>
									<SelectMulti
										isMulti
										isClearable
										uniqueKey='id'
										name='crepdecList'
										label='nomeExibicao'
										options={crepdecs}
										value={values.crepdecList || []}
										onChange={(item) => {
											setFieldValue('crepdecList', item);
										}}
									/>
								</div>
								<div className='col-6'>
									<label>Município</label>
									<SelectMulti
										isMulti
										isClearable
										uniqueKey='codigoIbge'
										name='municipio'
										label='nome'
										options={municipios}
										value={values.municipiosList || []}
										onChange={(item) => {
											setFieldValue('municipiosList', item);
										}}
									/>
								</div>
							</div>
						</React.Fragment>
					)}
				</BuscaAvancadaContext.Consumer>
			</BuscaAvancada>
		);
	}
}

export default PesquisaAvancadoPrestacaoContas;
